module.exports = __webpack_public_path__ + "img/img0405.b94fd037.png";